import { getAuthPlaceId } from './authPlaceStore'

/**
 * Current place ID for Firestore paths (places/{placeId}/...).
 * When authenticated, uses place from user profile; else falls back to env.
 */
export function getCurrentPlaceId(): string {
  const fromAuth = getAuthPlaceId()
  if (fromAuth) return fromAuth
  const id = import.meta.env.VITE_DEFAULT_PLACE_ID as string | undefined
  return id ?? 'place1'
}
